<template>
  <div>
    <div class="text-center">
      <ul class="social-buttons-list rounded text-center mb-0 py-3 pr-4 pl-4">
        <li
          @click="clickFBBtn"
          class="social-button-item list-inline-item mr-1 position-relative facebook"
          v-if="true"
        >
          <fb-signin-button
            :params="fbSignInParams"
            @success="onSignInSuccess"
            @error="onSignInError"
            ref="fbSigninButton"
          >
            <font-awesome-icon
              :icon="['fab', 'facebook-f']"
              size="2x"
              class="social-icon position-absolute"
            />
          </fb-signin-button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  mounted() {
    window.addEventListener("fb-sdk-ready", this.onFBReady);
  },

  beforeDestroy: function() {
    window.removeEventListener("fb-sdk-ready", this.onFBReady);
  },

  data() {
    return {
      isFBReady: false,
      fbSignInParams: {
        scope: "public_profile, email",
        auth_type: "rerequest"
      }
    };
  },

  methods: {
    ...mapActions(["handleFbLogin"]),

    clickFBBtn(event) {
      if (event.originalTarget && event.originalTarget.nodeName === "LI") {
        this.$refs.fbSigninButton.$refs.signinBtn.click();
      }
    },

    onSignInSuccess(response) {
      this.handleFbLogin(response);
    },

    onSignInError(error) {
      console.log("OH NO!", error);
    },

    onFBReady() {
      this.isFBReady = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_social_buttons.scss";

.social-buttons-list > .social-button-item {
  width: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/formModal/SocialSignIn.vue